export default "__VITE_ASSET__CzWy2yA7__"